@if (isArray) {
  @for (item of value; track item) {
    <app-multi-dimensional-view
      [childPropName]="childPropName"
      [content]="content"
      [value]="item || value"
      >
    </app-multi-dimensional-view>
  }
} @else {
  <ng-container *polymorpheusOutlet="content as content; context: value">
    {{content}}
  </ng-container>
  @if (value[childPropName]) {
    <app-multi-dimensional-view
      [childPropName]="childPropName"
      [content]="content"
      [value]="value[childPropName]"
      >
    </app-multi-dimensional-view>
  }
}
